<template>
  <div class="home-page login-content" style="padding-top: 0;">
    <Header></Header>
		<div class="login-content">
      <div class="landing-page login">
        <div class="">
           <div class="home-prize">
             <div class="home1">
               <img width="100%" style="margin-top: -0.4rem;" src="../../static/images/sen-otp.png" />
             </div>
           </div>
         <div class="ac fs33 app-en mt30" style="margin:0 auto 0.6rem;" v-if="type=='daily'" v-html="$t('cgtips2')"></div>
          <div class="ac fs33 app-en mt30" style="margin:0 auto 0.6rem;" v-if="type=='weekly'" v-html="$t('cgtips2W')"></div>
          <div class="ac fs33 app-en mt30" style="margin:0 auto 0.6rem;" v-if="type=='monthly'" v-html="$t('cgtips2M')"></div>
          <div class="input-div" style="margin-top:-1rem;">
            <div class="span mt30 fs33 crfff fw7" style="font-weight: 400;margin-bottom: 15px;">{{$t('phoneNumber')}}</div>
            <div class="input-item">
              <div class="input-item2">
                   <span class="app-en" style="height: 0.8rem;border-radius: 1rem;line-height: 0.8rem;font-size: 0.3rem;
    font-weight: 700;">+94</span>
                <input class="input" v-model="mobile" disabled placeholder="">
              </div>
            </div>
          </div>
          <div class="input-div">
            <div class="span fs33 crfff app-en fw7" style="font-weight: 400;margin-bottom: 15px;">OTP</div>
            <div class="input-item" style="background: none;">
              <div class="input-item2 disflex">
                <input class="input-item input" v-model="otp" maxlength="4" type="number" style="width: 100%;height:0.8rem;" placeholder="">
                <button class="btn btn-red" style="padding: 0 10px;min-height: 0.8rem;line-height: 0.8rem;min-width: 160px;margin-left:5px;font-size: 0.3rem;" :class="{disable:codeText != $t('getCode')}" type="none" :disabled="codeText != $t('getCode')" @click="getSendOtp">{{codeText}}</button>
              </div>
            </div>
          </div>
          <div class="ac mt50">
            <button class="button fw7" style="font-size:0.5rem;" @click="goLogin">{{$t('register')}}</button>
          </div>
          <div class="ac otp-b disflex crfff mt100">
            <div class="icon icon2" @click="getType('termsAndCondition')">{{$t('TC')}} <span class="app-en">>></span></div>
            <div class="icon icon2" @click="getType('faq')">{{$t('FAQ')}} <span class="app-en">>></span></div>
          </div>
        </div>
      </div>
		</div>
	</div>
</template>
<script>
import Header from '../components/HeaderTwo'
export default {
    components:{
		Header
    },
    data() {
      return {
        list:[],
        mobile:'',
        type:'',
        password:'',
        otp:'',
        codeText:'',
        isReturn:false,
        isEN:'bur'
      }
    },
    watch: {
			otp(now,old) {
				let that = this;
				that.$nextTick(function() {
					if(now.length==0){
						that.eyes1=false;
					}else{
						that.eyes1=true;
					}
					if(now.length==4||old==now){
						that.timer = setTimeout(() => {
							uni.hideKeyboard()
						}, 100);
					}
				});
			},
		},
	created(){
    this.codeText = this.$t('getCode')
    this.type = this.$route.query.type
    if (this.$route.query.mobile){
      this.mobile = this.dealPhone_2(this.$route.query.mobile)
      this.getSendOtp();
    }
	},
    methods: {
      getType(type){
          this.$router.push({path:'/'+type,query:{type:type}});
      },
      back(){
        this.$router.go(-1);
      },
      getSendOtp(){
        let that = this
        if(that.isReturn){
          return;
        }
        that.isReturn = true
        let mobile = '94'+this.mobile
        let data ={
            'mobile':mobile
        }
        that.$parent.loadModal(true);
        that.$api.post('/api/user/send_otp',data,r =>{
          that.$parent.loadModal(false);
          that.$utils.alertText(r.msg,80,3000);
          if (r.code == 1) {
            this.countDown(61, 1)
          } else {
            that.isReturn = false
          }
        })
      },
      goLogin(){
        let that = this
        if(that.mobile==''){
        	that.$utils.alertText(that.$t('loginTips'),60)
        	return;
        }
        if(that.otp==''){
          that.$utils.alertText(that.$t('otp_tips'),60)
          return;
        }
        var code  = this.$route.query.code
        let mobile = '94'+this.mobile
        let data ={
            'mobile':mobile,
            'otp':this.otp,
            'code':code,
            'channelId': this.$route.query.channelId,
        }
        that.$parent.loadModal(true);
        that.$api.post('/api/user/otp_login',data,r =>{
          that.$parent.loadModal(false);
          if(r.code==1){
            localStorage.setItem('token',r.data.userinfo.token)
            localStorage.setItem('mobile',r.data.userinfo.mobile)
            that.isShowlogin = false
            that.mobile = ''
            that.otp = ''
            this.$router.push({path:'/'})
          }else{
            that.$utils.alertText(r.msg,80);
          }
        })
      },
      // 计时
      countDown (miao,type){
      	if(miao === 1){
      		this.codeText = this.$t('getCode');
      		return;
      	}
      	miao--;
      	if(type === 1){
      		this.codeText = miao + "s";
          this.isReturn = false
      	}
      	setTimeout(() =>{
      		this.countDown(miao,type);
      	},1000)
      },
      dealPhone_2(phone) {
        phone = phone.replace(/\s+/g, ''); // 移除所有空格
        if (phone.startsWith('94')) {
          phone = phone.substring(2);
        }
        return phone;
      },
	}
}
</script>
<style scoped>
  .drop-down-content{z-index:9;background:none;}
  .otp-b{justify-content: space-evenly;}
  .login{margin-top:0px;}

  .btn-red{padding:20px 20px;background: #dd4765;width: auto;height: auto;display: block;margin: 0 auto;font-size:40px;}
</style>



// WEBPACK FOOTER //
// src/page/otp.vue